<!-- 右侧选项容器 -->
<template>
  <div class="right">
    <b-tabs v-model="tabIndex">
      <!-- 个人信息 -->
      <b-tab>
        <template slot="title">
          <el-tooltip content="个人信息" placement="top">
            <i class="el-icon-user"></i>
          </el-tooltip>
        </template>
        <div class="p-3">
          <div class="aside-options text-center">
            <img :src="userFace" style="width: auto; height: 100px" class="img-avatar" />
          </div>

          <hr />
          <h6>{{$t("common.action_lable")}}</h6>
          <div class="text-uppercase mb-1 mt-4">
            <el-button type="primary" class="el-icon-s-custom" style="width: 200px" @click="userInfoEdit">&nbsp;{{$t("common.my_info")}}
            </el-button>
          </div>
          <div class="text-uppercase mb-1 mt-2">
            <el-button type="danger" class="el-icon-s-custom" style="width: 200px" @click="resetPwd">&nbsp;{{$t("common.reset_pwd")}}</el-button>
          </div>
          <div class="text-uppercase mb-1 mt-2">
            <el-button type="warning" class="fa fa-lock" style="width: 200px" @click="$refs.warningModal.show()">
              &nbsp;&#12288;{{$t("common.logout")}}</el-button>
          </div>
        </div>
      </b-tab>

      <!-- 系统设置 -->
      <b-tab>
        <template slot="title">
          <el-tooltip content="设置" placement="top">
            <i class="icon-settings"></i>
          </el-tooltip>
        </template>
        <div class="p-3">
          <h6>{{$t("common.system")+$t("common.setting")}}</h6>
          <div class="aside-options">
            <div class="clearfix mt-4">
              <small>
                <b>{{$t("common.theme")}}</b>
              </small>
            </div>
            <div class="block mt-2">
              <div>
                <el-radio-group v-model="selectTheme" size="mini" @change="changeTheme">
                  <el-radio-button label="yellow">
                    <div style="
                        width: 20px;
                        height: 20px;
                        background: #fdc80a;
                        border: 2px solid #000;
                      " class="rounded"></div>
                  </el-radio-button>
                  <el-radio-button label="blue">
                    <div style="
                        width: 20px;
                        height: 20px;
                        background: #009fdf;
                        border: 2px solid #000;
                      " class="rounded"></div>
                  </el-radio-button>
                  <el-radio-button label="green">
                    <div style="
                        width: 20px;
                        height: 20px;
                        background: #67b419;
                        border: 2px solid #000;
                      " class="rounded"></div>
                  </el-radio-button>
                  <el-radio-button label="gray">
                    <div style="
                        width: 20px;
                        height: 20px;
                        background: #888b8d;
                        border: 2px solid #000;
                      " class="rounded"></div>
                  </el-radio-button>
                </el-radio-group>
              </div>
            </div>
            <div class="clearfix mt-4">
              <small>
                <b>{{$t("common.font_size")}}</b>
              </small>
            </div>
            <div class="block mt-2">
              <el-button size="mini" style="padding-left: 10px; padding-right: 10px; margin-left: 0" @click="setFontSize('8px')">
                {{$t("common.font_small")}}</el-button>
              <el-button size="small" style="
                  padding-left: 10px;
                  padding-right: 10px;
                  margin-left: 4px;
                " @click="setFontSize('12px')">{{$t("common.font_normal")}}</el-button>
              <el-button size="medium" style="
                  padding-left: 10px;
                  padding-right: 10px;
                  margin-left: 4px;
                " @click="setFontSize('16px')">{{$t("common.font_medium")}}</el-button>
              <el-button size="large" style="
                  padding-left: 10px;
                  padding-right: 10px;
                  margin-left: 4px;
                " @click="setFontSize('20px')">{{$t("common.font_large")}}</el-button>
            </div>
          </div>
        </div>
      </b-tab>
      <b-modal no-close-on-backdrop :title="$t('common.info')" centered header-bg-variant="warning" ref="warningModal" @ok="loginOut"
        :ok-title="$t('common.ok')" :cancel-title="$t('common.cancel')" ok-variant="warning">
        <h4>{{$t("notify.is_continue")}}</h4>
      </b-modal>
      <b-modal size="lg" no-close-on-backdrop :title="$t('common.password_manage')" centered ref="resetPasswordModal" hide-footer
        body-class="p-0">
        <resetPassword :isOnline="true" @closeResetPwdModal="closeResetPwdModal" style="height: 400px; width: 100%; min-height: auto">
        </resetPassword>
      </b-modal>
    </b-tabs>
  </div>
</template>

<script>
import resetPassword from "../views/pages/resetPassword";
import pinyinUtil from "../shared/pyconst";
import * as sessionStorageMgr from "../shared/sessionStorageMgr";
import * as localStorageMgr from "../shared/localStorageMgr";
import { Switch as cSwitch } from "@coreui/vue";
import QRCode from "qrcodejs2";
export default {
  name: "RightMenuConstainer",
  components: {
    cSwitch,
    resetPassword,
  },
  data: () => {
    return {
      tabIndex: 0,
      userFace: "/img/avatars/default_tx.jpg",
      selectTheme: "yellow",
    };
  },
  created() {
    if (this.$store.state.biz_data && this.$store.state.biz_data.plantSetting) {
      let _media_url = this.$store.state.biz_data.plantSetting.media_url;
      if (this.$store.state.biz_data.userInfo) {
        // this.userFace = _media_url + this.$store.state.biz_data.userInfo.icon_url
      }
    }
    this.selectTheme = localStorage.getItem("theme");
  },

  methods: {
    changeTheme(val) {
      this.$emit("changeTheme", val);
    },
    userInfoEdit() { },
    resetPwd() {
      //检查是否为域用户,域用户无法修改密码
      let user = this.$store.state.biz_data.userInfo.user_roles_privileges;
      // console.log(user);
      if (user) {
        if (user.isDomainUser) {
          this.msgToasts("抱歉,当前登录账户为域用户,无法修改密码!", "info");
          return;
        }
      }
      this.$refs.resetPasswordModal.show();
    },
    closeResetPwdModal() {
      this.$refs.resetPasswordModal.hide();
    },
    ///重新登录
    loginOut() {
      let account = this.$global.global_data.local_username;
      let locale = localStorageMgr.get(localStorageMgr.data.locale);
      localStorageMgr.clear();
      sessionStorageMgr.clear();
      if (account) {
        localStorageMgr.set(localStorageMgr.data.last_login_account, account);
      }
      if (locale) {
        localStorageMgr.set(localStorageMgr.data.locale, locale);
      }
      window.location.href = "/pages/Login?url=" + encodeURIComponent(window.location.href);
      // this.$router.push({ path: "/pages/login" }, () => { });
    },
    setFontSize(fontSize) {
      document.querySelector("html").style.fontSize = fontSize;
      // window.document.documentElement.setAttribute("font-size", fontSize)
    },
  },
};
</script>
<style scoped>
.nav .nav-item {
  width: auto !important;
}
</style>
